<template>
  <div class="Qr-Share">
    <el-dialog class="productTypeDialog" custom-class="planWordDialog" :append-to-body="true" title="" :visible.sync="qrShow" width="25%">
      <div class="Dialog-top" style="padding-top: 15px;">
        <p style="margin-bottom: 5px;font-weight: 700;">温馨提示：复制下方二维码,分享到手机端即可让用户浏览行程!</p>
        <Qr style="text-align: center;" :bgSrc="bgSrc" :logoSrc="logoSrc" :text="text"></Qr>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Qr from '../../../../components/Qr.vue';
export default {
  name:  '',
  components: {
    Qr
  },
  // 定义属性
  data() {
    return {
      priceDisplay:[],
      qrShow: false,
      budgetMainId: -1,
      planId: -1,
      logoSrc: require("@/assets/png/planQRLogo.png"),
      bgSrc: "",
      text: ""
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    priceDisplayChange(e) {
        this.priceDisplay = e
        this._builderQrCode()
    },
    init(budgetMainId,planId) {
      this.qrShow = true
      this.budgetMainId = budgetMainId
      this.planId = planId
      this._builderQrCode()
    },
    close() {
      this.qrShow = false
    },
    _builderQrCode() {
      let uri = process.env["VUE_APP_PLAN_SHARE_H5_SERVE"]
      uri = uri + `?budgetMainId=${this.budgetMainId}&planId=${this.planId}&priceDisplay=${encodeURIComponent(this.priceDisplay)}`
      console.log("lsdklfdf",uri)
      this.text = uri
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
  
</style>